import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { key: 3 }
const _hoisted_5 = { key: 4 }
const _hoisted_6 = { class: "toggle" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "hex" }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { class: "hex" }
const _hoisted_13 = { key: 3 }
const _hoisted_14 = { key: 4 }
const _hoisted_15 = { class: "toggle" }
const _hoisted_16 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OperationDetail = _resolveComponent("OperationDetail")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h4", {
      class: _normalizeClass({ 'new-partition': !_ctx.partition.oldPartitionInfo })
    }, _toDisplayString(_ctx.partition.partitionName), 3),
    (_ctx.isDynamicPartition)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("pre", null, "Dynamic:  ✅", -1)
        ]))]))
      : _createCommentVNode("", true),
    (_ctx.isFECEnabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("pre", null, "FEC:      ✅", -1)
        ]))]))
      : _createCommentVNode("", true),
    (_ctx.isHashtreeEnabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[4] || (_cache[4] = [
          _createElementVNode("pre", null, "Hashtree: ✅", -1)
        ]))]))
      : _createCommentVNode("", true),
    (_ctx.partition.estimateCowSize)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _cache[5] || (_cache[5] = _createElementVNode("strong", null, " Estimate COW Size: ", -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.partition.estimateCowSize) + " Bytes ", 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.partition.postinstallPath)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _cache[6] || (_cache[6] = _createElementVNode("strong", null, " Postinstall Script: ", -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.partition.postinstallPath), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("h4", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggle('showInfo'))),
        class: _normalizeClass({ active: _ctx.showInfo, inactive: !_ctx.showInfo })
      }, " Partition Infos ", 2),
      (_ctx.showInfo)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
            (_ctx.partition.oldPartitionInfo)
              ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                  _cache[7] || (_cache[7] = _createElementVNode("strong", null, " Old Partition Size: ", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.partition.oldPartitionInfo.size) + " Bytes ", 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.partition.oldPartitionInfo)
              ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                  _cache[8] || (_cache[8] = _createElementVNode("strong", null, " Old Partition Hash: ", -1)),
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.octToHex(_ctx.partition.oldPartitionInfo.hash, false, 16)), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("li", null, [
              _cache[9] || (_cache[9] = _createElementVNode("strong", null, " New Partition Size: ", -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.partition.newPartitionInfo.size) + " Bytes ", 1)
            ]),
            (_ctx.partition.newPartitionInfo.hash)
              ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                  _cache[10] || (_cache[10] = _createElementVNode("strong", null, " New Partition Hash: ", -1)),
                  _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.octToHex(_ctx.partition.newPartitionInfo.hash, false, 16)), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.partition.version)
              ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                  _cache[11] || (_cache[11] = _createElementVNode("strong", null, " Version: ", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.partition.version), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.readableTimestamp)
              ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                  _cache[12] || (_cache[12] = _createElementVNode("strong", null, " Version: ", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.readableTimestamp), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("h4", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggle('showOPs'))),
        class: _normalizeClass({ active: _ctx.showOPs, inactive: !_ctx.showOPs })
      }, " Total Operations: " + _toDisplayString(_ctx.partition.operations.length), 3),
      (_ctx.showOPs)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_16, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partition.operations, (operation) => {
              return (_openBlock(), _createElementBlock("li", {
                key: operation.dataSha256Hash
              }, [
                _createVNode(_component_OperationDetail, {
                  operation: operation,
                  mapType: _ctx.opType.mapType
                }, null, 8, ["operation", "mapType"])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}